<div class="md-form  input-group mb-3">
    <input name="icon-picker" id="icon-picker" triggers="click" mdbInput [mdbPopover]="popTemplate" #pop="bs-mdbPopover"
        placement="bottom" mdbPopoverHeader="{{ 'administration_chooseIcons_label' | translate }}" mdbWavesEffect
        type="text" [(ngModel)]="initIconPicker" class="form-control">
    <div *ngIf="initIconPicker" class="input-group-prepend" style="border: 1px #c0bcbc solid;background: #f7f7f7;">
        <span class="input-group-text md-addon ">
            <i class="cursor-pointer text-muted" class="{{initIconPicker}}" style="font-size:20px ; color:black"></i>
        </span>
    </div>
    <label data-error="wrong" data-success="right" for="icon-picker">{{ 'administration_chooseIcons_label' | translate }}</label>
</div>

<ng-template #popTemplate>
    <div class="icon-picker">
        <ul>
            <li *ngFor="let icon of icons" (click)="initIconPicker=icon;selectIcon(icon);pop.hide()">
                <i class="{{icon}}" style="font-size:20px ; color:black"></i>
            </li>
        </ul>
    </div>
</ng-template>